<template>
    <el-dialog title="绑定客户" :visible.sync="dialogVisible">
        <el-row class="searchSection">
            <SearchForm 
            :params="searcheModel" 
            :fields="fields" 
            :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
            :is_config="false"
            @search="submitSearch" 
            @reset="resetForm" 
            :key="search_form_key"> 
            </SearchForm>
        </el-row>
        <el-table
            :data="list" 
            border 
            height="660"
            @selection-change="handleSelectionChange"
            v-loading="loading">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="name" label="客户名称"></el-table-column>
            <el-table-column prop="corp_name" label="归属集团">
                <template slot-scope="scope">
                    <div v-for="(corp, index) in scope.row.corp" :key="index">
                        {{corp.corp_name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="district_names" label="所在地区"></el-table-column>
        </el-table>
        <br>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="bindCorp()" :loading="form_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CustomerStdService from "~/services/CustomerStd";
import MyPagination from "~/widgets/MyPagination.vue";
import SearchForm from "~/widgets/SearchForm.vue";
export default {
    name: "CustomerList",
    props: {
        params: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        customerId: "",
    },
    components: {
        MyPagination,
        SearchForm
    },
    
    data() {
        return {
            list: [],
            loading: false,
            multipleSelection: [],
            form: {
                customer_ids: [],
                memo: ''  
            },
            searcheModel: {},
            dialogVisible: true,
            linkPage: null,
            form_loading: false,
            fields: [],
            search_form_key: 100,
            active_name: 'bind-customer'
        }
    },

    created: function () {
        this.resetForm();
    },
    
    methods: {
        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //重置按钮
        resetForm() {
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'district_id', label: '所在地区', type: 'components', ref: 'district', components: 'DistrictCascader', change: 'changeDistrict'},
                ]},
            ];
            this.searcheModel = {};
            this.list = [];
            this.search_form_key ++;
            this.submitSearch();
        },

        //获取列表
        getList(params = {}) {
            // loading 动画
            this.loading = true;
            CustomerStdService.getList(params, 'index')
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },

        //绑定客户
        bindCorp() {
            const customer_ids = this.multipleSelection.map(item => item.id);
            if (customer_ids.length == 0){
                this.$message({
                    message:'请先选择需要绑定的客户',
                    type:'error'
                });
                return;
            }
            this.form_loading = true;
            CustomerStdService.bindCorp({corp_id: this.params.id, customer_ids: customer_ids}).then(res => {
                if (res.code == 0) {
                    this.$message({
                        message:'绑定成功',
                        type:'success'
                    });
                    this.form_loading = false;
                    this.dialogVisible = false;
                    this.$emit("change");
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/customer-std/dialog/CustomerList.vue